import { componentSizeMap } from '@hd-front-end/constants'

import type { ComponentSize } from '@hd-front-end/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
